import React from "react";
import { navigate } from "gatsby";

export default function LogoutButton() {
  return (
    <button
      className="underline underline-offset-4"
      onClick={() => {
        fetch(`/api/logout?token=${window.localStorage["google:tokens"]}`, {
          method: "POST",
        })
          .then(() => {
            window.localStorage.removeItem("google:tokens");
            navigate("/");
          })
          .catch((err) => {
            console.error(`Logout error: ${err}`);
          });
      }}
    >
      Logout
    </button>
  );
}
